import { inject, provide, type Ref } from "vue";

import type { Maybe } from "shared/types";

import { MODALS_OVERLAY_TARGET } from "./constants";

export function provideModalOverlayTarget(
  target: Ref<Maybe<HTMLElement>>
): void {
  provide(MODALS_OVERLAY_TARGET, target);
}

export function useModalOverlayTarget(): Maybe<Ref<Maybe<HTMLElement>>> {
  return inject(MODALS_OVERLAY_TARGET, undefined);
}

export default useModalOverlayTarget;
